import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SicAniaComponent } from './sic-ania.component';
import { ERoutes } from 'src/model/enum/sic-ania/routes.enum';

const routes: Routes = [
  {
      path: '',
      component: SicAniaComponent,
      children: [
        {
          path: ERoutes.DASHBOARD,
          loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
        }
      ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SicAniaRoutingModule {}
